import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_aec4c421-1889-412b-bd12-67a6d13a7d80/artifacts/hft02qmb_image.png";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const INSTAGRAM_URL = "https://www.instagram.com/nails.renss/";
export const PHONE = "0465 00 03 31";
export const PHONE_TEL = "+32465000331";
export const ADDRESS_LINE = "Sint-Amelbergastraat 44";
export const ADDRESS_CITY = "9700 Mater";
export const MAPS_QUERY = encodeURIComponent("Sint-Amelbergastraat 44, 9700 Mater, België");

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Er ging iets mis. Probeer opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function euro(v) {
  return "€" + Number(v).toFixed(2).replace(".", ",");
}
